import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="analytics-refresh"
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    this.refreshInterval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        this.refresh()
      }
    }, this.intervalValue)
  }

  stopRefreshing() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  }

  refresh() {
    const url = this.urlValue || window.location.href + '.json'

    fetch(url)
      .then(response => response.json())
      .then(data => {
        // Update key metrics without full page reload
        // You can dispatch a custom event here or update DOM elements
        this.dispatch('refreshed', { detail: data })
      })
      .catch(error => console.warn('Failed to update analytics:', error))
  }
}